// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J06fII2_fY_b5RV60vQi {
  flex-basis: 0;
  flex-grow: 1;
}

.ZiQeg1Ngfkq0SFgtY7u1 {
  box-sizing: border-box;
  padding: 16px;
  background-color: whitesmoke;
  border-radius: 8px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  display: flex;
  width: 100%;
}

.ZiQeg1Ngfkq0SFgtY7u1::-webkit-scrollbar {
  display: none;
}

.ZiQeg1Ngfkq0SFgtY7u1 .Yz7LIM31dVHtflAQZ7Pu {
  font-size: 13px;
  display: list-item;
  list-style-type: "\\f2f2";
  margin-left: 16px;
  padding-left: 8px;
  margin-bottom: 4px;
}

.ZiQeg1Ngfkq0SFgtY7u1 .Yz7LIM31dVHtflAQZ7Pu::marker {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: mediumseagreen;
}

.ZiQeg1Ngfkq0SFgtY7u1 .Yz7LIM31dVHtflAQZ7Pu a {
  color: var(--md-grey-colo);
  text-decoration: none;
}

.ZiQeg1Ngfkq0SFgtY7u1 .Yz7LIM31dVHtflAQZ7Pu a:hover {
  text-decoration: underline;
}

.ZiQeg1Ngfkq0SFgtY7u1 blockquote {
  font-style: italic;
  display: list-item;
  list-style-type: "\\f10d";
  margin: 0;
  padding: 0;
  margin-left: 1em;
  padding-left: 8px;
}

.ZiQeg1Ngfkq0SFgtY7u1 blockquote::marker {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: grey;
}

.ZiQeg1Ngfkq0SFgtY7u1 blockquote::before,
.ZiQeg1Ngfkq0SFgtY7u1 blockquote::after {
  content: "";
}

.ZiQeg1Ngfkq0SFgtY7u1 blockquote > mark {
  /* a lighter cornflowerblue */
  background-color: hsl(219, 79%, 87%);
}

.RsVcTev8p5XJGrYhS__P {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.yw8YwY8UsnUNDIWB7KOa {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.nlBtu28q6Jv0hrXfjFoR {
  width: 100%;
  display: flex;
  background-color: transparent;
  color: black;
  outline: none;
}

.FBk9NcPYTNYEDqAWlnlB {
  color: black;
  background-color: hsla(60, 20%, 98%, 0.881);
}

.uamvWxYMaFQllRumadRj,
.a8whw6cV6UhRwTeceZEQ,
.q_6cQOqv99f2GSxXpw9M,
.m6FLOtzBOX3FNMky62tR,
.Yz7LIM31dVHtflAQZ7Pu {
  font-size: 13px;
  margin-left: 16px;
  padding-left: 8px;
  margin-bottom: 4px;
  position: relative;
}

.uamvWxYMaFQllRumadRj::before,
.a8whw6cV6UhRwTeceZEQ::before,
.q_6cQOqv99f2GSxXpw9M::before,
.m6FLOtzBOX3FNMky62tR::before,
.Yz7LIM31dVHtflAQZ7Pu::before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  position: absolute;
  left: -16px;
}

.uamvWxYMaFQllRumadRj::before {
  content: "\\f3c5";
  color: var(--place-color);
}

.a8whw6cV6UhRwTeceZEQ::before {
  content: "\\f07e";
  color: var(--place-color);
}

.q_6cQOqv99f2GSxXpw9M::before {
  content: "\\f133";
  color: var(--date-color);
}

.m6FLOtzBOX3FNMky62tR::before {
  content: "\\f04b";
  color: mediumorchid;
}

.uamvWxYMaFQllRumadRj span {
  cursor: pointer;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
}

.uamvWxYMaFQllRumadRj span:hover {
  text-decoration: underline;
}

.a8whw6cV6UhRwTeceZEQ {
  font-size: 13px;
  list-style-type: "\\f07e";
  margin-left: 16px;
  padding-left: 8px;
  margin-bottom: 4px;
  color: var(--md-grey-colo);
}

.m6FLOtzBOX3FNMky62tR a {
  color: mediumorchid;
  text-decoration: none;
}

.m6FLOtzBOX3FNMky62tR a:hover {
  text-decoration: underline;
}

.QVP3oR55Zg1WVvojygEd {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.NfjODbKF8GJOrMMb11Wr {
  display: flex;
  justify-content: space-between;
  width: 90%;
}

.Zhlc7iHi7AgfyVoyGX5c {
  display: flex;
  width: 100%;
  padding-top: 0.5rem;
  justify-content: center;
}

.m6FLOtzBOX3FNMky62tR > a,
.Yz7LIM31dVHtflAQZ7Pu > a {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage/components/SearchResultsList/components/SearchResultItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;;;;;EAKE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;EAKE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB","sourcesContent":[".snippets {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n\n.snippetSlide {\n  box-sizing: border-box;\n  padding: 16px;\n  background-color: whitesmoke;\n  border-radius: 8px;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  display: flex;\n  width: 100%;\n}\n\n.snippetSlide::-webkit-scrollbar {\n  display: none;\n}\n\n.snippetSlide .timestamp {\n  font-size: 13px;\n  display: list-item;\n  list-style-type: \"\\f2f2\";\n  margin-left: 16px;\n  padding-left: 8px;\n  margin-bottom: 4px;\n}\n\n.snippetSlide .timestamp::marker {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: mediumseagreen;\n}\n\n.snippetSlide .timestamp a {\n  color: var(--md-grey-colo);\n  text-decoration: none;\n}\n\n.snippetSlide .timestamp a:hover {\n  text-decoration: underline;\n}\n\n.snippetSlide blockquote {\n  font-style: italic;\n  display: list-item;\n  list-style-type: \"\\f10d\";\n  margin: 0;\n  padding: 0;\n  margin-left: 1em;\n  padding-left: 8px;\n}\n\n.snippetSlide blockquote::marker {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: grey;\n}\n\n.snippetSlide blockquote::before,\n.snippetSlide blockquote::after {\n  content: \"\";\n}\n\n.snippetSlide blockquote > mark {\n  /* a lighter cornflowerblue */\n  background-color: hsl(219, 79%, 87%);\n}\n\n.customAccordionWrapper {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.accordionContent {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n.customAccordion {\n  width: 100%;\n  display: flex;\n  background-color: transparent;\n  color: black;\n  outline: none;\n}\n\n.customAccordionExpand {\n  color: black;\n  background-color: hsla(60, 20%, 98%, 0.881);\n}\n\n.location,\n.distance,\n.date,\n.more,\n.timestamp {\n  font-size: 13px;\n  margin-left: 16px;\n  padding-left: 8px;\n  margin-bottom: 4px;\n  position: relative;\n}\n\n.location::before,\n.distance::before,\n.date::before,\n.more::before,\n.timestamp::before {\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  position: absolute;\n  left: -16px;\n}\n\n.location::before {\n  content: \"\\f3c5\";\n  color: var(--place-color);\n}\n\n.distance::before {\n  content: \"\\f07e\";\n  color: var(--place-color);\n}\n\n.date::before {\n  content: \"\\f133\";\n  color: var(--date-color);\n}\n\n.more::before {\n  content: \"\\f04b\";\n  color: mediumorchid;\n}\n\n.location span {\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  text-align: left;\n}\n\n.location span:hover {\n  text-decoration: underline;\n}\n\n.distance {\n  font-size: 13px;\n  list-style-type: \"\\f07e\";\n  margin-left: 16px;\n  padding-left: 8px;\n  margin-bottom: 4px;\n  color: var(--md-grey-colo);\n}\n\n.more a {\n  color: mediumorchid;\n  text-decoration: none;\n}\n\n.more a:hover {\n  text-decoration: underline;\n}\n\n.accordionTopContent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.transcriptInfoRow {\n  display: flex;\n  justify-content: space-between;\n  width: 90%;\n}\n\n.textWidth {\n  display: flex;\n  width: 100%;\n  padding-top: 0.5rem;\n  justify-content: center;\n}\n\n.more > a,\n.timestamp > a {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"snippets": `J06fII2_fY_b5RV60vQi`,
	"snippetSlide": `ZiQeg1Ngfkq0SFgtY7u1`,
	"timestamp": `Yz7LIM31dVHtflAQZ7Pu`,
	"customAccordionWrapper": `RsVcTev8p5XJGrYhS__P`,
	"accordionContent": `yw8YwY8UsnUNDIWB7KOa`,
	"customAccordion": `nlBtu28q6Jv0hrXfjFoR`,
	"customAccordionExpand": `FBk9NcPYTNYEDqAWlnlB`,
	"location": `uamvWxYMaFQllRumadRj`,
	"distance": `a8whw6cV6UhRwTeceZEQ`,
	"date": `q_6cQOqv99f2GSxXpw9M`,
	"more": `m6FLOtzBOX3FNMky62tR`,
	"accordionTopContent": `QVP3oR55Zg1WVvojygEd`,
	"transcriptInfoRow": `NfjODbKF8GJOrMMb11Wr`,
	"textWidth": `Zhlc7iHi7AgfyVoyGX5c`
};
export default ___CSS_LOADER_EXPORT___;
